import React from 'react';

import './TableWrapper.scss';

interface Props {
  header?: JSX.Element;
  content?: JSX.Element;
}

const TableWrapper: React.FC<Props> = ({ children, header, content }) => {
  return (
    <div className="table-wrapper">
      {header && <div className="table-wrapper__header">{header}</div>}
      {content && <div className="table-wrapper__content">{content}</div>}
      {children}
    </div>
  );
};

export default TableWrapper;
